'use strict'
// Format config for textbook input table
// FOR PRIMARY 5ROWSx6COLS: 1=Display, 0=Disable, -1=Hide, 2=Mearge-2Rows
// FOR SECONDARY 17ROWSx6COLS: 1=Display, 0=Disable, -1=Hide, 2=Mearge-2Rows, 4=Mearge-4Rows
const textbookConfig = { // 5 subjects
  sjectPri: [
    'ភាសាខ្មែរ',
    'គណិតវិទ្យា',
    'វិទ្យាសាស្ត្រអនុវត្ត',
    'សិក្សាសង្គម',
    'ភាសាអង់គ្លេស'
  ],
  sjectSec: [ // 17 subjects
    'ភាសាខ្មែរ',
    'គណិតវិទ្យាកម្រិតមូលដ្ឋាន',
    'គណិតវិទ្យាកម្រិតខ្ពស់',
    'សីលធម៌-ពលរដ្ឋវិជ្ជា',
    'ប្រវត្តិវិទ្យា',
    'ភូមិវិទ្យា',
    'គេហវិទ្យា',
    'រូបវិទ្យា',
    'គីមីវិទ្យា',
    'ជីវវិទ្យា',
    'ផែនដី និងបរិស្ថាន',
    'សេដ្ឋកិច្ចវិទ្យា',
    'ភាសាអង់គ្លេស',
    'ភាសាបារាំង',
    'បច្ចេកវិទ្យា ICT',
    'អប់រំកាយនិងកីឡា',
    'ផ្សេងៗទៀត'
  ],
  tbMainTitle: [
    '១. ចំនួនសិស្ស គ្រូបង្រៀន និងថ្នាក់រៀន',
    '២. សៀវភៅសម្រាប់គ្រូឆ្នាំសិក្សាឆ្នាំសិក្សា ',
    '៣. សៀវភៅសិក្សាគោល',
    '៣. (ក) ចំនួនសៀវភៅសិក្សាដែលបានប្រមូលពីសិស្សពីឆ្នាំសិក្សាកន្លងមក ',
    '៣. (ខ) ចំនួនសៀវភៅសិក្សាថ្មីដែលបានទទួលនិងសៀវភៅសិក្សាដែលបានបែងចែកឱ្យសិស្សឆ្នាំសិក្សា '
  ],
  tbSubTitle: [
    'ចំនួនសៀវភៅណែនាំគ្រូដែលបានទទួលពីក្រសួងអប់រំ',
    'ចំនួនសៀវភៅណែនាំដែលបែងចែកដល់គូ្រ',
    'ចំនួនសៀវភៅសិក្សាដែលប្រមូលបានពីសិស្សឆ្នាំសិក្សា ',
    'ចំនួនសៀវភៅសិក្សាប្រមូលបានពីសិស្សនៅប្រើប្រាស់បាន',
    'ចំនួនសៀវភៅសិក្សាថ្មីដែលបានទទួលពីក្រសួងអប់រំ',
    'ចំនួនសៀវភៅសិក្សាដែលបានបែងចែកដល់សិស្ស'
  ],
  textbookBasicInfo: [0, 0, 0, 0, 0, 0],  // for 1st part of the FORM both primary and secondary
  textbookPri: [ // textbook config file for primary school
    [ 0, 0, 0, 0, 0, 0 ],
    [ 0, 0, 0, 0, 0, 0 ],
    [ 0, 0, 0, 0, 0, 0 ],
    [ 1, 1, 1, 0, 0, 0 ],
    [ 1, 1, 1, 0, 0, 0 ]
  ],
  textbookPriTitle: ['ថ្នាក់ទី១', 'ថ្នាក់ទី២', 'ថ្នាក់ទី៣', 'ថ្នាក់ទី៤', 'ថ្នាក់ទី៥', 'ថ្នាក់ទី៦'],
  textbookSec: [ // textbook config file for secondary school 17 rows
    [ 0, 0, 0, 0, 0, 0 ],
    [ 0, 0, 0, 0, 0, 0 ],
    [ 1, 1, 1, 0, 0, 0 ],
    [ 0, 0, 0, 0, 0, 0 ],
    [ 1, 1, 1, 1, 0, 0 ],
    [ 1, 1, 1, 1, 0, 0 ],
    [ 1, 1, 1, 1, 0, 0 ],
    [ 0, 0, 0, 0, 0, 0 ],
    [ 1, 1, 1, 0, 0, 0 ],
    [ 1, 1, 1, 0, 0, 0 ],
    [ 1, 1, 1, 0, 0, 0 ],
    [ 1, 1, 1, 1, 0, 0 ],
    [ 0, 0, 0, 0, 0, 0 ],
    [ 0, 0, 0, 0, 0, 0 ],
    [ 1, 1, 1, 0, 0, 0 ],
    [ 0, 0, 0, 0, 0, 0 ],
    [ 0, 0, 0, 0, 0, 0 ]
  ],
  textbookSecTitle: ['ថ្នាក់ទី៧', 'ថ្នាក់ទី៨', 'ថ្នាក់ទី៩', 'ថ្នាក់ទី១០', 'ថ្នាក់ទី១១', 'ថ្នាក់ទី១២']
}

module.exports = textbookConfig
